<template>
    <div
        cy-data="error"
        :class="[error ? '' : 'hidden', 'error']"
        @click="deleteError"
    >
        {{ error }}
    </div>
</template>

<script lang="ts">
import { defineComponent, computed, onBeforeUnmount, onMounted } from 'vue';
import { useStore } from 'vuex';
import { DELETE_ERROR } from '@/constants/mutation-types';

export default defineComponent({
    name: 'Error',
    props: {
        name: {
            type: String,
            default: '',
        },
        valueField: {
            type: String,
            default: '',
        },
    },
    setup(props) {
        const store = useStore();
        const error = computed(() => store.state.errors.get(props.name) || '');

        const deleteError = () => {
            store.commit(DELETE_ERROR, props.name);
        };

        const deleteErrorOnFieldClick = (evt: MouseEvent) => {
            const targetElement = evt.target as HTMLFormElement;
            if (
                (targetElement.localName === 'input' ||
                    targetElement.localName === 'div') &&
                targetElement.name === props.name
            ) {
                deleteError();
            }
        };

        onMounted(() => {
            document.addEventListener('click', deleteErrorOnFieldClick);
        });

        onBeforeUnmount(() => {
            document.removeEventListener('click', deleteErrorOnFieldClick);
        });

        return {
            error,
            deleteError,
        };
    },
});
</script>
